import {
  LBDialog,
  LBDialogContent,
  LBDialogDescription,
  LBDialogFooter,
  LBDialogHeader,
  LBDialogTitle
} from '@linearb/buzz';
import useScopesValidationsModalHandler from './useScopesValidationsModalHandler';
import useScopesValidations from './useScopesValidations';
import { PROVIDERS_MAP } from 'common/constants/constants';
import { CircularProgress } from '@material-ui/core';
import ScopesValidations from './ScopesValidations';
import ScopesValidationsActionButton from './ScopesValidationsActionButton';
import ScopesValidationsInfo from './ScopesValidationsInfo';

const ScopesValidationsModal = ({ sensor }) => {
  const modalHandler = useScopesValidationsModalHandler(sensor);
  const scopesValidations = useScopesValidations({
    sensor,
    enabled: modalHandler.isOpen
  });
  const providerMap = PROVIDERS_MAP[sensor?.sensor_name?.toLowerCase()];
  const pmSensorName = providerMap?.name ?? sensor?.name ?? '';

  const { isLoading } = scopesValidations;

  return (
    <LBDialog open={modalHandler.isOpen} onOpenChange={modalHandler.closeModal}>
      <LBDialogContent className='z-[1001]' overlayClassName='z-[1000]'>
        <LBDialogHeader>
          <LBDialogTitle className='flex items-center'>
            {pmSensorName} connection in progress
            {isLoading && (
              <div className='relative top-1 ml-4'>
                <CircularProgress size={17} />
              </div>
            )}
          </LBDialogTitle>
          <LBDialogDescription>
            {isLoading
              ? 'Running scopes validations'
              : 'Scopes validation status'}
          </LBDialogDescription>
        </LBDialogHeader>
        <ScopesValidations scopesValidations={scopesValidations} />
        <ScopesValidationsInfo
          scopesValidations={scopesValidations}
          sensorName={pmSensorName}
        />
        <LBDialogFooter className='mt-8'>
          <ScopesValidationsActionButton
            sensor={sensor}
            scopesValidations={scopesValidations}
            modalHandler={modalHandler}
          />
        </LBDialogFooter>
      </LBDialogContent>
    </LBDialog>
  );
};

export default ScopesValidationsModal;
